import React from "react";
import { Element } from "react-scroll";
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";
import "./Projects.css";

const Projects = () => {
  const projects = [
    {
      title: "Cinetra - Movie Recommendation App",
      description:
        "This project is a React application that provides movie recommendations based on user preferences. It includes features such as search, filtering, and detailed movie information using the TMDB API.",
      technologies: ["React", "Tailwind", "Django", "TMDB API", "PostgreSQL", "JWT", "bcryptjs"],
      githubLink: "https://github.com/Nikhil-Negi-tech/cinetraBackend",
      liveDemo: "https://cinetra-by-nikhil.vercel.app",
    },
    {
      title: "DIAGNOFAST - Quantum Medical Diagnosis System",
      description:
        "Medical diagnosis system with interactive symptom selection, smart disease matching, and medicine recommendations. Features responsive design and real-time results.",
      technologies: ["React", "Node.js", "MongoDB", "Quantum API", "Neural Networks", "Machine Learning", "JWT"],
      githubLink: "https://github.com/Nikhil-Negi-tech/Diagnofast-backend",
      liveDemo: "https://diagnofast-by-nikhil-negi.vercel.app/",
    },
    {
      title: "Blog App - Real-time Collaborative Blogging",
      description:
        "A real-time collaborative blog application that allows users to create, update, and delete posts. It features user authentication and uses Firebase for backend services.",
      technologies: ["React", "Firebase", "CSS3", "JavaScript", "Redux", "Thunks"],
      githubLink: "https://github.com/Nikhil-Negi-tech/blog-app-backend",
      liveDemo: "https://blog-app-by-nikhil-negi.vercel.app/",
    },
    {
      title: "ML Based Network Intrusion Detection System",
      description:
        "An advanced machine learning application built with Streamlit that detects network intrusions and cyber threats in real-time. Uses sophisticated ML algorithms to analyze network traffic patterns and identify potential security breaches, providing comprehensive threat assessment and security insights.",
      technologies: ["Python", "Streamlit", "Machine Learning", "Cybersecurity", "Pandas", "Scikit-learn", "NumPy", "Network Analysis"],
      githubLink: "https://github.com/Nikhil-Negi-tech/Machine-Learning-Based-Network-Intrusion-Detection-App-By-Nikhil-Negi",
      liveDemo: "https://nikhil-negi-tech-ml-based-network-intrusion-detection.streamlit.app/",
    },
    {
      title: "India House Price Prediction",
      description:
        "A machine learning web application built with Streamlit that predicts house prices in India based on various property features. Demonstrates practical implementation of data science concepts, machine learning algorithms, and web development skills using modern Python frameworks.",
      technologies: ["Python", "Streamlit", "Machine Learning", "Data Science", "Pandas", "Scikit-learn", "NumPy"],
      githubLink: "https://github.com/Nikhil-Negi-tech/India-House-Price-Prediction",
      liveDemo: "https://india-house-price-prediction-by-nikhil-negi.streamlit.app/",
    },
    {
      title: "Portfolio Website",
      description:
        "Responsive personal portfolio website showcasing projects, skills, and experience. Built with modern web technologies and optimized for performance and SEO. ",
      technologies: ["React", "CSS3", "JavaScript", "Vercel", "AOS", "Scroll"],
      githubLink: "https://nikhil-negi-portfolio.vercel.app/",
      liveDemo: "https://nikhil-negi-portfolio.vercel.app/",
    }
  ];
// new file
  return (
    <Element name="projects">
      <section className="projects" style={{ padding: "2rem 2rem" }}>
        <div className="projects-container">
          <h2 className="section-title">Featured Projects</h2>
          <div className="projects-grid">
            {projects.map((project, index) => (
              <div
                key={index}
                className="project-card"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="project-content">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <div className="project-technologies">
                    {project.technologies.map((tech, techIndex) => (
                      <span key={techIndex} className="tech-tag">
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="project-links">
                  <a
                    href={project.githubLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-link github-link"
                  >
                    <FaGithub /> GitHub
                  </a>
                  <a
                    href={project.liveDemo}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-link demo-link"
                  >
                    <FaExternalLinkAlt /> Live Demo
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Element>
  );
};

export default Projects;
